import CardActionArea, { CardActionAreaProps } from "@material-ui/core/CardActionArea"
import { wrapLink, LinkProps } from "./Link";



export type CardActionAreaLinkProps =  Omit<CardActionAreaProps, "component"> & LinkProps;
export const CardActionAreaLink = wrapLink<CardActionAreaLinkProps>(CardActionArea);

